export const IS_DEBUG_MODE = process.env.VUE_APP_IS_DEBUG_MODE === 'true';
export const IS_PRODUCTION_MODE = process.env.VUE_APP_IS_PRODUCTION_MODE === 'true';

export const USER_LOGIN = 'API.Booking';
export const USER_PWD_HASH = '3b3e9bf9e01962fe4fb9ef658533392e';

export const AUTHORIZE_PAYMENT = 'https://api.authorize.net/xml/v1/request.api';

export const AUTHORIZE_NET = {
	login: IS_PRODUCTION_MODE ? '4sM5P5pML' : '4sM5P5pML',
	transactionKey: IS_PRODUCTION_MODE ? '2Py95mpZnn5B99Yn' : '2Py95mpZnn5B99Yn',
	validationMode: IS_PRODUCTION_MODE ? 'liveMode' : 'liveMode', // testMode, liveMode
};
